import React, { useEffect } from "react";
import "./EcoPalmProducts.css";
import Card from "../../../../components/Card";
import Breadcrumb from "../../../../components/Breadcrum";

// Centralized image import for better management
const images = {
  ECO: "./assets/img/ecoPalmProducts/ECO.jpg",
  ECO_RT1: "./assets/img/ecoPalmProducts/ECO_RT1.jpg",
  ECO_RT2: "./assets/img/ecoPalmProducts/ECO_RT2.jpg",
  ECO_RT3: "./assets/img/ecoPalmProducts/ECO_RT3.jpg",
  ECO_RT4: "./assets/img/ecoPalmProducts/ECO_RT4.jpg",
  ECO_RT5: "./assets/img/ecoPalmProducts/ECO_RT5.jpg",
  ICON_1: "./assets/img/ecoPalmProducts/ICON_1.png",
  ICON_2: "./assets/img/ecoPalmProducts/ICON_2.png",
  ICON_3: "./assets/img/ecoPalmProducts/ICON_3.png",
  banner: "./assets/img/contact-banner.png",
};

const cardData = [
  {
    id: "gourmet-dinner-plates",
    image: images.ECO_RT5,
    title: "Gourmet Dinner Plates",
    description:
      "Crafted for main courses, these plates provide a sturdy and stylish base for your meals.",
  },
  {
    id: "snack-platters",
    image: images.ECO_RT2,
    title: "Snack Platters",
    description:
      "Perfect for appetizers, finger foods, and desserts, adding a touch of sophistication to any event.",
  },
  {
    id: "soup-salad-bowls",
    image: images.ECO_RT4,
    title: "Soup & Salad Bowls",
    description:
      "Deep and durable, these bowls are ideal for serving hot soups or fresh salads.",
  },
  {
    id: "party-serving-trays",
    image: images.ECO_RT1,
    title: "Party Serving Trays",
    description:
      "Spacious and robust, these trays make serving multiple dishes effortless during events or gatherings.",
  },
  {
    id: "custom-shapes-sizes",
    image: images.ECO_RT3,
    title: "Custom Shapes & Sizes",
    description:
      "Tailored options available to suit your unique dining or catering needs with exceptional versatility.",
  },
];

export default function EcoPalmProducts() {
  // Ensuring smooth scroll restoration
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Breadcrumb
        title="ECOPALM PRODUCTS"
        backgroundImage={images.banner}
        height="40vh"
      ></Breadcrumb>
      <section className="main-services cardContainer pt-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="service-item mb-5">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="left-image">
                      <img src={images.ECO} alt="Digital Currencies" />
                    </div>
                  </div>
                  <div className="col-lg-8 align-self-center">
                    <div className="right-text-content">
                      <i className="fas fa-archive"></i>
                      <span className="heading">ECO-PALM PRODUCTS</span>
                      <span className="subData">
                        Crafted by Nature, Perfected by us
                      </span>
                      <p className="justify">
                        At Dohrnii, we supply premium-quality tableware crafted
                        from naturally fallen areca palm leaves, delivering
                        eco-friendly solutions that combine sustainability with
                        elegance. Our range includes plates, bowls, and trays
                        designed to meet diverse dining needs, perfect for
                        homes, events, and catering services. With a commitment
                        to quality and the environment, we ensure every product
                        reflects our dedication to sustainable living and
                        exceptional craftsmanship.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="cardContainer">
        <div className="container">
          <div className="row g-lg-5 g-4">
            {cardData.map((card) => (
              <div key={card.id} className="col-lg-4 col-md-6 col-12">
              <Card
                key={card.id}
                image={card.image}
                title={card.title}
                id={card.id}
                description={card.description}
                className="h-100"
              />
              </div>
            ))}
          </div>
        </div>
      </div>
      <section>
        <section className="banner-bg bg-white py-5">
          <div className="container my-4">
            <div className="row text-center objectiveContainer">
              {/* Size and Shape */}
              <div className="objective col-lg-3">
                <div className="objective-icon card m-auto py-4 mb-2 mb-sm-4 bg-secondary shadow-lg">
                  <img src={images.ICON_1} className="display-1 text-white" />
                </div>
                <h2 className="objective-heading h3 mb-2 mb-sm-4 light-300">
                  SIZE AND SHAPE
                </h2>
                <p className="light-300">
                  Choose from a variety of sizes and shapes to suit different
                  dining needs, from elegant dinner plates to practical serving
                  bowls.
                </p>
              </div>

              {/* Branding */}
              <div className="objective col-lg-3 mt-sm-0 mt-4">
                <div className="objective-icon card m-auto py-4 mb-2 mb-sm-4 bg-secondary shadow-lg">
                  <img src={images.ICON_2} className="display-1 text-white" />
                </div>
                <h2 className="objective-heading h3 mb-2 mb-sm-4 light-300">
                  BRANDING
                </h2>
                <p className="light-300">
                  Custom branding options are available for businesses looking
                  to add their logo or message to the products, perfect for
                  events or corporate caterings.
                </p>
              </div>

              {/* Packaging */}
              <div className="objective col-lg-3 mt-sm-0 mt-4">
                <div className="objective-icon card m-auto py-4 mb-2 mb-sm-4 bg-secondary shadow-lg">
                  <img src={images.ICON_3} className="display-1 text-white" />
                </div>
                <h2 className="objective-heading h3 mb-2 mb-sm-4 light-300">
                  PACKAGING
                </h2>
                <p className="light-300">
                  Custom Packaging options allow for personalized branding and
                  messaging, ideal for gifts or special occasions.
                </p>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
}
